import { useMutation } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { ICreateAuditData, IAuditIngestResponse } from './types';

/**
 * Hook para criar um log de auditoria
 * Envia o log para a API de forma assíncrona
 */
export const useCreateAudit = () => {
  return useMutation<IAuditIngestResponse, Error, ICreateAuditData>({
    mutationFn: async (data: ICreateAuditData) => {
      const response = await configApi.post<IAuditIngestResponse>('/audit/ingest/', data);
      return response.data;
    },
    retry: 3, // Tenta até 3 vezes em caso de falha
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  });
};
